import {
  AnyApiFactory,
  analyticsApiRef,
  configApiRef,
  createApiFactory,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';
import {
  ScmAuth,
  ScmIntegrationsApi,
  scmIntegrationsApiRef,
} from '@backstage/integration-react';
import { CustomMetricsAnalytics } from '@internal/backstage-plugin-custom-metrics/analytics';

import { bitbucketProjectsApiRef } from './components/scaffolder/utils/BitbucketProjectsApi';
import { BitbucketProjectsClient } from './components/scaffolder/utils/BitbucketProjectsClient';
import { githubOrgsApiRef } from './components/scaffolder/utils/GithubOrgsApi';
import { GithubOrgsClient } from './components/scaffolder/utils/GithubOrgsClient';
import { qualityGatesApiRef } from './components/scaffolder/utils/QualityGatesApi';
import { QualityGatesClient } from './components/scaffolder/utils/QualityGatesClient';

export const apis: AnyApiFactory[] = [
  createApiFactory({
    api: scmIntegrationsApiRef,
    deps: { configApi: configApiRef },
    factory: ({ configApi }) => ScmIntegrationsApi.fromConfig(configApi),
  }),
  ScmAuth.createDefaultApiFactory(),
  // Bitbucket Projects API
  createApiFactory({
    api: bitbucketProjectsApiRef,
    deps: {
      discoveryApi: discoveryApiRef,
      fetchApi: fetchApiRef,
    },
    factory: ({ discoveryApi, fetchApi }) =>
      new BitbucketProjectsClient({ discoveryApi, fetchApi }),
  }),
  createApiFactory({
    api: githubOrgsApiRef,
    deps: {
      discoveryApi: discoveryApiRef,
      fetchApi: fetchApiRef,
    },
    factory: ({ discoveryApi, fetchApi }) =>
      new GithubOrgsClient({ discoveryApi, fetchApi }),
  }),
  // SonarCloud Quality Gates API
  createApiFactory({
    api: qualityGatesApiRef,
    deps: {
      discoveryApi: discoveryApiRef,
      fetchApi: fetchApiRef,
    },
    factory: ({ discoveryApi, fetchApi }) =>
      new QualityGatesClient({ discoveryApi, fetchApi }),
  }),
  // Custom Metrics Analytics listener – forwards navigate/create/search events to the backend
  createApiFactory({
    api: analyticsApiRef,
    deps: {
      discoveryApi: discoveryApiRef,
      fetchApi: fetchApiRef,
    },
    factory: ({ discoveryApi, fetchApi }) =>
      new CustomMetricsAnalytics({ discoveryApi, fetchApi }),
  }),
];
